export default __webpack_public_path__ + "static/media/gallery2.dd13709d.jpg";